module.exports = __webpack_public_path__ + "static/media/c-sign.8f96f2bf.svg";